export function setSession (key, value) {
  if (value instanceof Object) {
    value = JSON.stringify(value)
  }
  sessionStorage.setItem(key, value)
}

export function getSession (key) {
  let obj = sessionStorage.getItem(key)
  if (typeof obj === 'string') {
    obj = JSON.parse(obj)
  }
  return obj
}

export const userInfo = 'userInfo'
export const storeInfo = 'storeInfo'
export const inspectionInfo = 'inspectionInfo'
export const databaseInfo = 'databaseInfo'
export const storeChange = 'storeChange'
export const listSave = 'listSave'
export const radioSave = 'radioSave'
export const page1 = 'page1'
export const page2 = 'page2'
export const page3 = 'page3'
export const radio2 = 'radio2'
export const data = 'data'
export const clientTab = 'clientTab'
export const queryInfo = 'queryInfo'
export const salesData = 'salesData'
export const parametersInfo = 'parametersInfo'




// WEBPACK FOOTER //
// ./src/tools/config.js